export default __webpack_public_path__ + "static/media/hht2_ep16_speaking_02.8cd45c8d.png";